export default __webpack_public_path__ + "static/media/AzureEventHubs.cda13a8a.md";